import { buildCheckoutRedirectUrl } from '@/utils/checkoutRedirectOrigin';

export function buildPublicSessionAccessUrl(
	roomId: string,
	userName?: string | null,
): string {
	const trimmedRoomId = roomId.trim();
	const base = buildCheckoutRedirectUrl(
		`/sessao/acesso/${encodeURIComponent(trimmedRoomId)}`,
	);

	const trimmedUserName = userName?.trim();
	if (!trimmedUserName) {
		return base;
	}

	const url = new URL(base);
	url.searchParams.set('userName', trimmedUserName);
	return url.toString();
}

export function resolveVideoRoomId(videoRoom: {
	room_id?: string | null;
	room_url?: string | null;
}): string | null {
	const fromId = videoRoom.room_id?.trim();
	if (fromId) {
		return fromId;
	}

	if (!videoRoom.room_url?.trim()) {
		return null;
	}

	try {
		const pathname = new URL(videoRoom.room_url).pathname.replace(
			/^\/+/,
			'',
		);
		const segment = pathname.split('/').filter(Boolean)[0];
		return segment ?? null;
	} catch {
		return null;
	}
}
